var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      class: _vm.labelClass,
      attrs: {
        id: "date-input",
        label: _vm.dateName,
        "label-for": "date-input",
        "invalid-feedback": _vm.date.invalidFeedback,
        state: _vm.date.state
      }
    },
    [
      _c("vc-date-picker", {
        ref: "date-input",
        attrs: {
          mode: _vm.mode,
          "is-dark": "",
          is24hr: "",
          locale: "fr",
          color: "yellow",
          "max-date": _vm.minDate,
          popover: { visibility: "click" },
          "minute-increment": 5,
          "first-day-of-week": 2,
          modelConfig: _vm.modelConfig,
          "is-required": _vm.isRequired
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var inputValue = ref.inputValue
              var inputEvents = ref.inputEvents
              return [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dateInput,
                      expression: "dateInput"
                    }
                  ],
                  staticClass: "border px-2 py-1 rounded date-datepicker",
                  class: { "is-invalid": _vm.date.state === false },
                  attrs: {
                    placeholder: _vm.dateName,
                    required: _vm.isRequired
                  },
                  domProps: { value: _vm.dateInput },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.dateInput = $event.target.value
                      },
                      _vm.formatDate
                    ],
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.updateDateValue.apply(null, arguments)
                    },
                    blur: _vm.updateDateValue
                  }
                })
              ]
            }
          }
        ]),
        model: {
          value: _vm.date.value,
          callback: function($$v) {
            _vm.$set(_vm.date, "value", $$v)
          },
          expression: "date.value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9b60880", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9b60880","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/editFields/DateField.vue
// module id = Bfg7
// module chunks = 0